export const RQ_GET_OVERVIEW_REPORTS_USER_API = {
  url:'expensemaster/status-report',
  method:'POST',
  auth:true,
};
